var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FactoryMaterial',{ref:"r0",attrs:{"order-id":_vm.orderId}}),_c('PurchaseReport',{ref:"r1",attrs:{"order-id":_vm.orderId}}),_c('MakeReport',{ref:"r2",attrs:{"order-id":_vm.orderId}}),_c('MoneyReport',{ref:"r3",attrs:{"order-id":_vm.orderId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }